export default function isFormattedDate() {
  return (value) => {
    if (isNaN(Date.parse(value))) {
      throw new Error(JSON.stringify({ id: 'reformulate.date_wrong_format' }))
    }
  }
}
